import React from "react";
import "./PlurixHeader.scss";
import Logo from "../../../../assets/images/LogoPlurix.png";
import vibe from "../../../../assets/images/HeaderTopo2Plurix.png";

const PlurixHeader = ({ product }) => {
  return (
    <>
      <div className="plurix-redemption-code-header">
        <img src={Logo} alt="Vibe" />
      </div>
      <div className="banner-img">
        <img src={vibe} alt="Vibe" />
      </div>
    </>
  );
};

export default PlurixHeader;
